(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('CampaignService', CampaignService);

    CampaignService.$inject = ['CampaignFactory'];

    function CampaignService(CampaignFactory) {
        var service = {
            listAll: listAll,
            createCampaign: createCampaign,
            deleteCampaign: deleteCampaign,
            distribute: distribute,
            activateOrInactivate: activateOrInactivate,
            get: get,
            getCampaignSettings: getCampaignSettings,
            saveCampaignSettings: saveCampaignSettings
        };

        return service;

        function listAll(params) {
            return CampaignFactory.listAll(params).$promise;
        }

        function createCampaign(campaign) {
            return CampaignFactory.save(campaign).$promise;
        }

        function deleteCampaign(campaignId) {
            return CampaignFactory.delete({ id: campaignId }).$promise;
        }

        function distribute(id, request) {
            return CampaignFactory.distribute({id: id}, request).$promise;
        }

        function activateOrInactivate(id, request) {
            return CampaignFactory.activateOrInactivate({id: id}, request).$promise;
        }

        function get(campaignId) {
            return CampaignFactory.get({ id: campaignId }).$promise;
        }

        function getCampaignSettings() {
            return CampaignFactory.getCampaignSettings().$promise;
        }

        function saveCampaignSettings(settings) {
            return CampaignFactory.saveCampaignSettings(settings).$promise;
        }
    }
})();
